import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/OneTimeProductName";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Get = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const AddOrUpdate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddOrUpdate`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export default {
  GetAll,
  Get,
  AddOrUpdate,
  Delete,
};
